<div class="container">
    <div class="row">
        <div class="col-12 mb-5">
            <app-toolkit-page-title [title]="pageType === 'ricerca' ? 'Ricerca Opera' : 'Approva Opere'">
                <button type="button" class="btn btn-outline-primary mt-3" [routerLink]="['../crea']" *ngIf="pageType === 'ricerca' && (utenteService.isRuoloAmministratore() || utenteService.isRuoloOperatore())">
                    <app-toolkit-bl-icon icon="plus" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                    <span class="d-none d-md-inline-block">Inserisci opera</span>
                </button>
            </app-toolkit-page-title>
            <div class="card">
                <div class="card-body">
                    <form class="form" role="form" [formGroup]="criteriaForm" (ngSubmit)="submitForm(true)">
                        <div class="form-row">
                            <h6 class="col-12">Ricerca Territoriale</h6>
                            <div class="form-group col-md-3">
                                <label for="codProv">Provincia</label>
                                <select class="form-control" formControlName="codProv" id="codProv" (change)="searchComuniByProvincia()">
                                    <option [ngValue]="null">Seleziona un'opzione...</option>
                                    <option *ngFor="let provincia of datalist.province" [ngValue]="provincia.id">{{ provincia.descrizione }}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-3">
                                <label for="codIstat">Comune</label>
                                <input #inputComuni type="text" class="form-control" id="codIstat" placeholder="Seleziona un'opzione..."
                                    formControlName="comune"
				                    [ngbTypeahead]="filterComuni"
                                    [inputFormatter]="comuneFormatter"
			                        [resultFormatter]="comuneFormatter"
                                    (selectItem)="selectItemComuni($event)"
                                    [editable]="false"
			                        />
                            </div>
                        </div>
                        <div class="form-row pt-2">
                            <h6 class="col-12">Ricerca Intervento</h6>
                            <div class="form-group col-md-3">
                                <label for="idOpera">ID Opera</label>
                                <input class="form-control" id="idOpera" formControlName="idOpera" type="number">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="idTipologiaOpera">Tipologia opera</label>
                                <select class="form-control" formControlName="idTipologiaOpera" id="idTipologiaOpera">
                                    <option [ngValue]="null">Seleziona un'opzione...</option>
                                    <option *ngFor="let tipologiaOpera of datalist.tipologiaOpera" [ngValue]="tipologiaOpera.idTipologiaOpera">{{ tipologiaOpera.descrizioneTipologiaOpera }}</option>
                                </select>
                            </div>
                            <!-- <div class="form-group col-md-3">
                                <label for="idTipoIntervento">Stato vita opera</label>
                                <select class="form-control" formControlName="idTipoIntervento" id="idTipoIntervento">
                                    <option [ngValue]="null">Seleziona un'opzione...</option>
                                    <option *ngFor="let tipologiaIntervento of datalist.tipologiaIntervento" [ngValue]="tipologiaIntervento.id">{{ tipologiaIntervento.descrizione }}</option>
                                </select>
                            </div> -->

                            <div class="form-group col-md-3">
                                <label for="provenienza">Provenienza</label>
                                <input class="form-control" id="provenienza" formControlName="provenienza" type="text">
                            </div>
                            
                            <div class="form-group col-md-3">
                                <label for="cup">CUP</label>
                                <input class="form-control" id="cup" formControlName="cup" type="text">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="trattoIdrico">Corso d'acqua</label>
                                <input class="form-control" id="trattoIdrico" formControlName="trattoIdrico" type="text">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="idMaterialeCostruzione">Materiale costruzione</label>
                                <select class="form-control" formControlName="idMaterialeCostruzione" id="idMaterialeCostruzione">
                                    <option [ngValue]="null">Seleziona un'opzione...</option>
                                    <option *ngFor="let materiale of datalist.materiale" [ngValue]="materiale.id">{{ materiale.descrizione }}</option>
                                </select>
                            </div>
                            <div *ngIf="pageType !== 'approva-opera'" class="form-group col-md-3">
                                <label for="idStato">Stato</label>
                                <select class="form-control" formControlName="idStato" id="idStato">
                                    <option [ngValue]="null">Seleziona un'opzione...</option>
                                    <option *ngFor="let statoOpera of datalist.statoOpera" [ngValue]="statoOpera.id">{{ statoOpera.descrizione }}</option>
                                </select>
                            </div>

                        </div>
                        <div class="button-actions">
                            <button type="button" class="btn btn-outline-primary" (click)="resetForm()">Pulisci</button>
                            <button type="submit" class="btn btn-primary">Ricerca</button>
                        </div>
                    </form>
                </div>
            </div>
            <div class="card mt-4">
                <div class="card-body">
                    <h6 id="table_description">Risultati ricerca</h6>
                    <div style="transform: rotateX(180deg);" class="table-responsive mb-3" >
                        <table style="transform: rotateX(180deg);" class="table table-striped table-sm" aria-describedby="table_description">
                            <thead class="thead-light">
                                <tr>
                                    <th scope="col"><app-toolkit-table-sort title="ID" (sortTableOutput)="sortTable($event, 0)" [tableSortField]="tableSort[0]" [disabled]="!tableData.length"></app-toolkit-table-sort></th>
                                    <th scope="col"><app-toolkit-table-sort title="Provincia" (sortTableOutput)="sortTable($event, 1)" [tableSortField]="tableSort[1]" [disabled]="!tableData.length"></app-toolkit-table-sort></th>
                                    <th scope="col"><app-toolkit-table-sort title="Comune" (sortTableOutput)="sortTable($event, 2)" [tableSortField]="tableSort[2]" [disabled]="!tableData.length"></app-toolkit-table-sort></th>
                                    <th scope="col">Macro tipologia opera</th>
                                    <th scope="col">Tipologia opera</th>
                                    <th scope="col">Provenienza</th>
                                    <th scope="col">Materiale costruzione</th>
                                    <th scope="col">Corso d'acqua</th>
                                    <th style="min-width: 85px;" scope="col">CUP</th>
                                    <th scope="col">Stato</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of tableData"  >
                                    <td>{{ item.idOpera }}</td>
                                    <td>{{ item.denProv}}</td>
                                    <td>{{ item.denComune }}</td>
                                    <td>{{ item.macroTipologiaOpera | anagraficaMacroTipologiaOpera: (datalist.macroTipologiaOpera || []) }}</td>
                                    <td>{{ item.idTipologiaOpera | anagraficaTipologiaOpera: (datalist.tipologiaOpera || []) }}</td>
                                    <td ><div class ="text-truncate" style="max-width: 100px;" [ngbTooltip] ="item.provenienza" placement="top"> {{ item.provenienza }} </div></td>
                                    <td>{{ item.idMaterialeCostruzione | anagraficaMateriale: (datalist.materiale || []) }}</td>
                                    <td>{{ item.trattoIdrico }}</td>
                                    <td>{{ item.cups[0]?.toString() }}<app-toolkit-bl-icon *ngIf="item.cups.length > 1" triggers="click:blur" container="body" [ngbTooltip]="item.cups.slice(1).toString()" icon="plus" cssClass="icon icon-sm icon-primary pl-2"></app-toolkit-bl-icon></td>
                                    <td>{{ item.idStato | anagraficaStatoOpera: (datalist.statoOpera || [])}}</td>
                                    <td class="actions">
                                        <button aria-label="Accedi al dettaglio" type="button" class="btn btn-xs btn-link"
                                            (click)="goToOpera(item.idOpera)"
                                            container="body" ngbTooltip="Accedi al dettaglio">
                                            <app-toolkit-bl-icon icon="arrow-right" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                                        </button>
                                        <button  aria-label="Accedi al viewer" type="button" class="btn btn-xs btn-link ml-1"
                                            (click)="goToViewer(item.idOpera, item.codIstat, item.idTipologiaOpera)"
                                            container="body" ngbTooltip="Accedi al viewer">
                                            <app-toolkit-bl-icon icon="map-marker" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                                        </button>
                                    </td>
                                </tr>
                                <tr *ngIf="!tableData.length">
                                    <td colspan="13"><p class="mb-0 text-center">Nessun risultato trovato.</p></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <ngb-pagination
                        *ngIf="tableData.length"
                        [(page)]="paginator.page"
                        [pageSize]="paginator.size"
                        [collectionSize]="paginator.total"
                        (pageChange)="onPageChange($event)"
                        [maxSize]="5"
                        ></ngb-pagination>
                    <div *ngIf="pageType !== 'approva-opera'" class="button-actions">
                        <button type="button" [ngbTooltip]="tooltipEsporta" class="btn btn-outline-primary mt-3" (click)="searchExport()" *ngIf="tableData.length && (utenteService.isRuoloAmministratore() || utenteService.isRuoloOperatore())">
                            <app-toolkit-bl-icon icon="download" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                            Esporta risultati
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
